export enum ForgetOperation {
  ATTEMPTS_EXCEEDED_USER_LOGIN = '89242',
  BLOCKED_USER = '88217',
  USER_NOT_FOUND = '89243'
}
export enum HomeOperation {
  LISTADO = '80180',
  SUBHOME = '80170',
  PRODUCTO = '80100',
  PRODUCTO_ERROR = '80171',
  RECIBOS = '80101',
  RECIBOS_DETALLE = '80176',
  SINIESTROS = '80102',
  SINIESTRO_DETALLE = '80172',
  DUPLICADO_POLIZA_ENVIO_OK = '80212',
  DUPLICADO_POLIZA_ERROR_ENVIO = '80611',
  BUZON = '80177',
  BUZON_KO = '89581',
  AVISO_RENOVACION_OK = '88736',
  AVISO_RENOVACION_ERROR = '88738',
  AVISO_RENOVACION_NO_DISPONIBLE = '88737',
  ABRIR_APP_SALUD = '89570',
  DESCARGAR_APP_SALUD = '89571',
  ABRIR_APP_AFIN = '89572',
  DESCARGAR_APP_AFIN = '89573'
}
export enum AutoOperation {
  LISTADO = '80180',
  SUBHOME = '80170',
  PRODUCTO = '80100',
  PRODUCTO_ERROR = '80171',
  RECIBOS = '80101',
  RECIBOS_DETALLE = '80176',
  SINIESTROS = '80102',
  SINIESTRO_DETALLE = '80148',
  BUZON = '80177',
  AVISO_RENOVACION_OK = '88736',
  AVISO_RENOVACION_ERROR = '88738',
  AVISO_RENOVACION_NO_DISPONIBLE = '88737',
  CAMBIO_PRODUCTO = '89391',
  CHANGE_HABITUAL_ADDRESS = '89385'
}
export enum LifeOperation {
  LISTADO = '80180',
  SUBHOME = '80170',
  PRODUCTO = '80100',
  PRODUCTO_ERROR = '80171',
  RECIBOS = '80101',
  RECIBOS_DETALLE = '80176',
  DUPLICADO_POLIZA_ENVIO_OK = '80212',
  DUPLICADO_POLIZA_ERROR_ENVIO = '80611',
  AVISO_RENOVACION_OK = '88736',
  AVISO_RENOVACION_ERROR = '88738',
  AVISO_RENOVACION_NO_DISPONIBLE = '88737',
  DUPLICADO_FISCAL_ERROR = '89132',
  PARTICIPACION_BENEFICIOS_OK = '89135',
  PARTICIPACION_BENEFICIOS_KO = '89136',
  RENTAS_LISTADO = '89130'
}
export enum PenInvOperation {
  LISTADO = '80180',
  SUBHOME = '80170',
  PRODUCTO = '80100',
  PRODUCTO_ERROR = '80171',
  RECIBOS = '80101',
  RECIBOS_DETALLE = '80176',
  MOVIMIENTOS = '80174',
  MOVIMIENTOS_DETALLE_OK = '80288',
  FONDOS = '80131',
  ESTADO_POSICION = '88577',
  ERROR_ESTADO_POSICION = '88578',
  INFORME_TRIMESTRAL = '80134',
  ERROR_INFORME_TRIMESTRAL = '88579',
  ACCESO_INVERSIS = '80719',
  ERROR_SIN_PERIMISO_INVERSIS = '89010',
  ERROR_MANTENIMIENTO_INVERSIS = '89011',
  ERROR_ACCESO_INVERSIS = '80720',
  INICIO_CALCULO_VALORACION = '89036',
  NO_DISPONIBILIDAD_AÑO_FISCAL = '89677'
}
export enum HealthOperation {
  LISTADO = '80180',
  SUBHOME = '80170',
  PRODUCTO = '80100',
  PRODUCTO_ERROR = '80171',
  RECIBOS = '80101',
  RECIBOS_DETALLE = '80176',
  ASISTENCIAS = '80126',
  AUTORIZACIONES = '80127',
  AUTORIZACIONES_ERROR = '89114',
  REEMBOLSOS = '89116',
  COPAGO = '89026',
  COPAGO_SIN_CARTAS = '89027',
  DUPLICADO_TARJETA_OK = '89118',
  DUPLICADO_TARJETA_ERROR = '89119',
  AVISO_RENOVACION_OK = '88736',
  AVISO_RENOVACION_ERROR = '88738',
  AVISO_RENOVACION_NO_DISPONIBLE = '88737',
  ABRIR_APP_SALUD = '89570',
}
export enum TechOperation {
  OVERALL_POSITION = '80001',
  OVERALL_POSITION_REDUCED = '89580',
  OVERALL_POSITION_SINGLE_BRANCH_ERROR = '89124',
  OVERALL_POSITION_ALL_BRANCHES_ERROR = '89109',
  OVERALL_POSITION_EMPTY = '89594',
  VALIDATION_OIM = '80000',
  VALIDATION_OIM_FINGERPRINT = '88504',
  VALIDATION_OIM_FACEID = '88505'
}
export enum TeCuidamosOperation {
  ACCESS = '88000',
  ERROR_ACCESS = '88001',
  CARD = '88002',
  ERROR_CARD = '88003',
  SAVING = '88004',
  ERROR_SAVING = '88005',
  STABLISHMENTS = '88006',
  ERROR_STABLISHMENTS = '88007',
  SERVICES = '88008',
  ERROR_SERVICES = '88009',
  SSO_OK = '89303',
  SSO_KO = '89304'
}

export enum OthersOperation {
  LISTADO = '80180',
  SUBHOME = '80170',
  PRODUCTO = '80100',
  PRODUCTO_ERROR = '80171',
  RECIBOS = '80101',
  RECIBOS_DETALLE = '80176',
  SINIESTROS = '80102',
  SINIESTRO_DETALLE = '80172',
  DUPLICADO_POLIZA_OK = '80212',
  DUPLICADO_POLIZA_ERROR = '80611',
  BUZON = '80177',
  AVISO_RENOVACION_OK = '88736',
  AVISO_RENOVACION_ERROR = '88738',
  AVISO_RENOVACION_NO_DISPONIBLE = '88737',
  ACCESO = '89411',
  ACCESO_CORRESPONDENCE = '89413',
  CONTACTA = '89584',
  SUPPORT = '89587'
}

export enum ContactProductId {
  CHANGE_PHONE = 'Cambio teléfono',
  REGISTER = 'Registro',
  LOGIN = 'Login',
  FORGOT_PASSWORD = 'Olvido de contraseña',
  CONTACT = 'Contacto'
}

export enum PatrimonialsOperation {
  ABANDONO = '8080',
  INICIO = '8081',
  FALLO_POR_NORMATIVA = '8082',
  ERROR_SERVICIO = '8083',
  TIPO_NO_DISPONIBLE = '8084',
  SELECCION_TIPO = '8085',
  RESUMEN_Y_CONFIRMACION = '8087',
  ENVIO_SMS_KO = '9204',
  ENVIO_SMS_OK = '9205',
  CODIGO_SEGURIDAD_INVALIDO_CLIENTE = '9206',
  SMS_INTENTOS_AGOTADOS = '9207',
  CODIGO_SEGURIDAD_VALIDO = '9208',
  SERVICIO_CONSULTA_POLIZA = '9210',
  LISTADO_POLIZAS_OK = '9209',
  LISTADO_POLIZAS_KO = '9202'
}

export enum RGPDUEPWAPatrimonials {
  ACEPTACION_CONDICIONES = '8068'
}

export enum AutoSinister {
  SELECCION_LUNAS = '88513',
  SELECCION_SIN_CONTRARIO = '88514',
  SELECCION_DAÑOS_CARGADOR = '89371',
  SELECCION_CON_CONTRARIO = '88515',
  INICIO = '88081',
  TIPO_NO_DISPONIBLE = '88084',
  SELECCION_TIPO = '88085'
}

export enum PaymentOperation {
  CODIGO_SEGURIDAD_INVALIDO_CLIENTE = '78013',
  SMS_INTENTOS_AGOTADOS = '78014',
  CODIGO_SEGURIDAD_VALIDO = '78012',
  SIN_RECIBOS_PENDIENTES = '78009',
  RECIBO_MOSTRADO_CORRECTO_PRIVADA = '88903',
  TRON_NO_DISPONIBLE_PRIVADA = '88925',
  SERVICIO_VIDA_FUERA_DE_HORARIO_PRIVADA = '88739',
  RECIBO_MOSTRADO_INCORRECTO_PRIVADA = '88902',
  CANCELAR_PAGO_PRIVADA = '88916',
  INICIO_PAGO_TARJETA_PRIVADA = '88905',
  INICIO_PAGO_AMAZON_PRIVADA = '88953',
  INICIO_PAGO_BIZUM_PRIVADA = '89636',
  CANCELAR_PAGO_TARJETA_PRIVADA = '88906',
  GENERACION_PDF_JUSTIFICANTE_PAGO_PRIVADA = '88961',
  ERROR_GENERACION_PDF_JUSTIFICANTE_PAGO_PRIVADA = '88963',
  GENERACION_PDF_DUPLICADO_RECIBO_PRIVADA = '88960',
  ERROR_GENERACION_PDF_DUPLICADO_RECIBO_PRIVADA = '88962',
  INICIO_PAGO_PAYPAL_PRIVADA = '88935',
  CANCELAR_PAGO_PAYPAL_PRIVADA = '88937',
  PAGO_CLAVE_INCORRECTA_PRIVADA = '88938',
}

export enum SuperbonusOperation {
  ACCESO_SUPERBONUS = '80748'
}

export enum FamiliesOperation {
  ACEPTACION_CONDICIONES = '88146',
  ACEPTA_CONDICIONES = '88134',
  ACEPTA_INVITACION = '88145',
  ADHESION_KO = '89216',
  ADHESION_OK = '88147',
  CREATE_FAMILY = '88135',
  CREATE_RELATIVE = '88142',
  ERROR_CREATE_FAMILY = '89212',
  ERROR_CREATE_RELATIVE = '89215',
  ERROR_FAMILY_SERVICE = '88184',
  ERROR_REMOVE_FAMILY = '89213',
  ERROR_REMOVE_RELATIVE = '89214',
  INICIO = '88183',
  LEAVE_PROCESS = '89218',
  NOT_CONSISTENT_DATA = '88129',
  RECHAZA_INVITACION = '88148',
  RECHAZO_OK = '88149',
  REJECT_KO = '89217',
  RELATIVE_WITHOUT_FAMILY = '88130',
  REMOVE_FAMILY = '88153',
  REMOVE_RELATIVE = '88151'
}

export enum FamiliesStructureTitle {
  ACCEPT_INVITATION = 'Datos del cliente que está aceptando la invitación',
  ACEPTA_CONDICIONES = 'Familias: OI. Aceptación condiciones',
  ACEPTA_INVITACION = 'Datos del cliente que está aceptando la invitación',
  ADHESION_KO = 'Familias: OE. ERROR Familiar - Adhesión',
  ADHESION_OK = 'Familias: OB. Familiar - Adhesión OK',
  CREATE_FAMILY = 'Familias: OB. Creada familia',
  CREATE_RELATIVE = 'Familias: OB. Creador - Familiar añadido',
  ERROR_CREATE_FAMILY = 'Familias: OE. Error familia no creada',
  ERROR_CREATE_RELATIVE = 'Familias: OE. ERROR Creador - Familiar añadido',
  ERROR_FAMILY_SERVICE = 'Familias: OE. Error servicio RIC',
  ERROR_REMOVE_FAMILY = 'Familias: OE. ERROR Creador - Eliminar Familia',
  ERROR_REMOVE_RELATIVE = 'Familias: OE. ERROR Creador - Eliminar Familiar',
  INICIO = 'Familias: OI. Inicio',
  LEAVE_PROCESS = 'Familias: OI. Cliente abandona',
  NOT_CONSISTENT_DATA = 'Familias: OI. Aviso datos no consistentes RIC',
  RECHAZA_INVITACION = 'Datos del cliente que está rechazando la invitación',
  RECHAZO_OK = 'Datos del cliente que ha rechazado la invitación',
  REJECT_INVITATION = 'Datos del cliente que está rechazando la invitación',
  REJECT_KO = 'Familias: OE. ERROR Familiar - Rechazo',
  REJECT_OK = 'Familias: OB. Familiar - Rechazo OK',
  RELATIVE_WITHOUT_FAMILY = 'Familias: OI. Aviso Familiar sin familia',
  REMOVE_FAMILY = 'Familias: OB. Creador - Eliminar Familia OK',
  REMOVE_RELATIVE = 'Familias: OB. Creador - Eliminar Familiar OK'
}

export enum CarSinisterWithoutContraryOperation {
  PRESTAMO = '88510',
  GUARDAR = '88511',
  ABANDONO = '88512',
  OTROS_DANOS_PRESENTES = '88516',
  DANOS_SOLO_VEHICULO = '88517',
  GOLPE_UNICO = '88518',
  GOLPES_ACUMULADOS = '88519',
  DATOS_GENERALES_SINIESTRO = '88520',
  DATOS_DANOS_VEHICULO = '88521',
  DATOS_DANOS_ADICIONALES = '88522',
  RESUMEN_DATOS = '88523',
  DATOS_CONTACTO = '88524'
}

export enum CarSinisterRepairOperation {
  SELECCION_TIPO_TALLER_CONTINUO = '88525',
  SELECCION_TIPO_TALLER_DIFERIDO = '88557',
  ERROR_SELECCION_TIPO_TALLER_CONTINUO = '88526',
  CENTRO_SERVICIO_CONTINUO = '88527',
  CENTRO_SERVICIO_DIFERIDO = '88543',
  VEHICULO_CORTESIA_CONTINUO = '88537',
  VEHICULO_CORTESIA_DIFERIDO = '88555',
  TALLER_DISTINGUIDO_CONTINUO = '88528',
  TALLER_DISTINGUIDO_DIFERIDO = '88544',
  OTRO_TALLER_CONTINUO = '88530',
  OTRO_TALLER_DIFERIDO = '88546',
  ABANDONO = '88559',
  RO_OP_024 = '88529',
  RO_OP_044 = '88545'
}

export enum CarSinisterConsultationOperation {
  INICIO_ENVIO_DOC = '89050',
  INICIO_CONSULTA_TRAMITADOR = '89052',
  ACCESO_COMUNICACIONES = '89055',
  ACCESO_DOCUMENTOS = '89058'
}

export enum PaymentPlanOperation {
  LISTADO = '88201',
  ACCESO = '88336',
  ACCESO_TRAS_CONTRATACION = '88338',
  DESCARGA_CONTRATO_SIN_FIRMAR = '88203',
  ACCESO_REDSYS = '89510'
}

export enum HelpOperation {
  ACCESO = '88330',
  PREGUNTA_OK = '88331',
  PREGUNTA_KO = '88332'
}

export enum RoadAssistanceOperation {
  ACCESS = '88570',
  PHONE_CALL = '89033',
  GEOLOCATION = '89034',
  GEOLOCATION_ERROR = '89032',
  CONTACT_SENT = '88571',
  CONTACT_SENT_ERROR = '88572',
  TAXI_SELECTED = '89423',
  TAXI_SENT = '89424',
  TAXI_SENT_ERROR = '89425',
  DEFERRED_SELECTED = '89426',
  BREAKDOWN_SELECTED = '89428',
  BATTERY_SELECTED = '89429',
  FUEL_SELECTED = '89430',
  BLOWOUT_SELECTED = '89431',
  ACCIDENT_SELECTED = '89432',
  OTHER_SELECTED = '89433',
  CALL_RESTRICTIONS = '89434',
  GEOLOCATION_COMMENTS = '89436',
  ABANDON = '89437'
}

export enum ProfileOperation {
  CAMBIO_DATOS_INICIO = '89065',
  CAMBIO_DATOS_ABANDONO = '89066',
  CAMBIO_MOVIL_INICIO = '89069',
  CAMBIO_MOVIL_CLIENTE_KO = '89070',
  CAMBIO_MOVIL_CLIENTE_OK = '89071',
  CAMBIO_MOVIL_DEFINIR_NUEVO_NUMERO = '89072',
  CAMBIO_MOVIL_SMS_KO = '89073',
  CAMBIO_MOVIL_SMS_OK = '89074',
  CAMBIO_MOVIL_CLIENTE_IDENTIFICADO_KO = '89075',
  CAMBIO_MOVIL_CLIENTE_IDENTIFICADO_OK = '89076',
  CAMBIO_DIRECCION_INICIO = '89079',
  CAMBIO_DIRECCION_ABANDONO = '89080',
  CAMBIO_CONTRASEÑA_INICIO = '89083',
  CAMBIO_CONTRASEÑA_ANTIGUA_CLAVE_KO = '89084',
  CAMBIO_CONTRASEÑA_DEFINIR_CLAVE = '89085',
  CAMBIO_CONTRASEÑA_ABANDONO = '89086',
  CAMBIO_CONTRASEÑA_KO = '89088',
  CAMBIO_PREGUNTA_SEGURIDAD_INICIO = '89089',
  CAMBIO_PREGUNTA_SEGURIDAD_ANTIGUA_CLAVE_KO = '89090',
  CAMBIO_PREGUNTA_SEGURIDAD_DEFINIR_PREGUNTA = '89091',
  CAMBIO_PREGUNTA_SEGURIDAD_ABANDONO = '89092',
  SOLICITAR_NUEVA_CLAVE_INICIO = '88617',
  SOLICITAR_NUEVA_CLAVE_SMS_KO = '88618',
  SOLICITAR_NUEVA_CLAVE_SMS_OK = '88619',
  SOLICITAR_NUEVA_CLAVE_CLIENTE_KO = '88621',
  SOLICITAR_NUEVA_CLAVE_CLIENTE_OK = '88620',
  SOLICITAR_NUEVA_CLAVE_DEFINIR_CLAVE = '88622',
  MODIFICAR_CLAVE_INICIO = '88625',
  MODIFICAR_CLAVE_DEFINIR = '88626',
  MODIFICAR_CLAVE_ANTERIOR_CLAVE_KO = '88627',
  CANCELAR_CLAVE_INICIO = '89095',
  CANCELAR_CLAVE_SMS_KO = '89096',
  CANCELAR_CLAVE_SMS_OK = '89097',
  CANCELAR_CLAVE_CLIENTE_KO = '89098',
  CANCELAR_CLAVE_CLIENTE_OK = '89099'
}

export enum PolicyBaseTypeToProductId {
  car = 'Autos',
  home = 'Diversos',
  other = 'Diversos',
  accident = 'Diversos',
  death = 'Diversos',
  pension = 'Inversion',
  investment = 'Inversion',
  'investment-nova' = 'Inversion',
  life = 'Vida',
  saving = 'Vida',
  health = 'Salud'
}

export enum BankDataManagementRO {
  INICIO = '89270',
  CAMBIO_CUENTA_NORMATIVA = '89272',
  CLAVE_NO_OPERATIVA = '89274',
  VALIDACION_CLAVE_KO = '89275',
  VALIDACION_CLAVE_OK = '89276',
  ERROR_SERVICIO_CAMBIO_CUENTA = '89362'
}

export enum RgpdueRights {
  HOME = '89317',
  REQUEST_SENT = '89318',
  REQUEST_ERROR = '89319',
  ONE_TRUST_OK = '88068',
  ONE_TRUST_KO = '88268'
}

export enum VehicleChangeRO {
  ACCESS = '89394',
  CANCEL_PROCESS = '89395',
  VEHICLE_BRAND_SELECTED = '89396',
  VEHICLE_ID_ACCESS = '89399',
  VEHICLE_FOUND = '89400',
  VEHICLE_SELECTED = '89401',
  VEHICLE_NOT_SELECTED = '89402',
  VEHICLE_NOT_FOUND = '89403',
}

export enum VehiclePaymentChangeRO {
  ACCESS = '89388',
  ACCESS_PDP = '89408',
  SUSCEPTIBLE_ERROR = '89407',
}

export enum VehiclePaymentChangeStructure {
  ACCESS = 'Cambio Forma de pago: OI. Acceso',
  ACCESS_PDP = 'Cambio Forma de pago: OI. Acceso Plan de Pagos',
  SUSCEPTIBLE_ERROR = 'Cambio Forma de pago: OE. Error Consulta susceptible'
}

export enum NonRenewalRO {
  CANCELLATION_REQUEST_START = '89155',
  KEY_NOT_OPERATIVE = '89156',
  SUCCESS_VALIDATION_KEY = '89157',
  ERROR_VALIDATION_KEY = '89158',
  REQUEST_SEND_ERROR = '89261',
  REQUEST_SEND_SUCCESS = '89260',
  CANCELLATION_REQUEST_CANCELED = '89262',
  NOT_SUSCEPTIBLE_PAYMENT_PLAN = '89263',
  SUSCEPTIBLE_PAYMENT_PLAN = '89264',
  PAYMENT_PLAN_INFO = '89265',
  EXPIRATION_KEY = '89266',
  NON_OPERATIONAL = '89267',
  BLOQUED_KEY = '89268',
  SUSCEPTIBLE_QUERY_ERROR = '89269'
}

export enum NonRenewalROStructure {
  CANCELLATION_REQUEST_START = 'Inicio',
  KEY_NOT_OPERATIVE = 'Clave no operativa',
  SUCCESS_VALIDATION_KEY = 'Validación clave correcta',
  ERROR_VALIDATION_KEY = 'Validación clave incorrecta',
  REQUEST_SEND_ERROR = 'Error anulación de póliza',
  REQUEST_SEND_SUCCESS = 'Anulación de póliza',
  CANCELLATION_REQUEST_CANCELED = 'Cancela solicitud de anulación',
  NOT_SUSCEPTIBLE_PAYMENT_PLAN = 'Consulta no susceptible plan de pagos',
  SUSCEPTIBLE_PAYMENT_PLAN = 'Consulta susceptible',
  PAYMENT_PLAN_INFO = 'Información plan de pagos',
  EXPIRATION_KEY = 'No renovación anulación al vencimiento',
  NON_OPERATIONAL = 'Póliza no en vigor',
  BLOQUED_KEY = 'Validación clave bloqueada',
  SUSCEPTIBLE_QUERY_ERROR = 'Error consulta susceptible'
}

export enum RegistersRO {
  START = '88120',
  SMS_ERROR = '80716',
  SMS_SUCCESS = '88503',
  LEAVE = '88307',
  IDENTIFIED = '80710',
  NO_IDENTIFIED = '80711',
  FORM_ACCEPTED = '80712',
  TE_CUIDAMOS = '80713',
  GLOBALPOSITION = '80714',
  CUSTOMER_NO_TE_CUIDAMOS = '88077',
  CUSTOMER_TE_CUIDAMOS = '89313',
  INCOMMING_CALL = '88500',
  CLIENT_NO_PROFILE = '80721',
}

export enum RegistersStructure {
  START = 'Proceso de Alta: OI. Inicio',
  SMS_ERROR = 'Proceso de Alta: OI. Fallo envío SMS',
  SMS_SUCCESS = 'Proceso de Alta: OI. Envío SMS',
  LEAVE = 'Proceso de Alta: OI. Cliente Abandona',
  IDENTIFIED = 'Proceso de Alta: OI. Cliente Identificado',
  NO_IDENTIFIED = 'Proceso de Alta: OI. Cliente No identificado',
  FORM_ACCEPTED = 'Proceso de Alta: OI. Formulario Aceptación',
  TE_CUIDAMOS = 'Proceso de Alta: OI. Acceso a teCuidamos',
  GLOBALPOSITION = 'Proceso de Alta: OI. Acceso Posicion Global',
  CUSTOMER_NO_TE_CUIDAMOS = 'Proceso de Alta: OI. Cliente NO desea teCuidamos',
  CUSTOMER_TE_CUIDAMOS = 'Proceso de Alta: OI. Cliente Desea teCuidamos',
  INCOMMING_CALL = 'Proceso de Alta: OI. Cliente llamada entrante',
  CLIENT_NO_PROFILE = 'Proceso de Alta: OI. Aviso Cliente no perfil'
}

export enum MultiMapOperation {
  SSO_INCORRECTO = '89560',
  SSO_CORRECTO = '89561',
  INICIO_SOLICITUD = '89562',
  SOLICITUD_PROFESIONAL = '89563',
  ERROR_SOLICITUD_PROFESIONAL = '89564',
  INICIO_CONSULTA = '89565',
  ERROR_SERVICIO_CONSULTA = '89566',
  CONSULTA = '89567',
  ENVIO_MENSAJE = '89568',
  ERROR_MENSAJE = '89569'
}

export enum OnOffPolicyOperation {
  CALL_COVERAGES_CHANGE = '89706',
  ACTIVATE_START = '89755',
  PREMIUM_SELECTION = '89756',
  VERIFICATION_REQUEST = '89757',
  VERIFICATION_REQUEST_ERROR = '89758',
  ADVANCE_SELECTION = '89759',
  ACTIVATE_OK = '89760',
  ACTIVATE_ERROR = '89761',
  DEACTIVATE_START = '89762',
  DEACTIVATE_OK = '89763',
  DEACTIVATE_ERROR = '89764',
  ABANDON = '89765',
  SERVICE_ERROR = '89766',
  CUE_NOTIFICATION_ERROR = '89767'
}

export enum MedicalCheckUpsOperation {
  MEDICAL_HEADQUARTERS_ACCESS = '89678',
  CHECKUP_ACCESS = '89681',
  APPOINTMENT_ACCESS = '89682',
}

export enum MedicalCheckUpsStructure {
  MEDICAL_HEADQUARTERS_ACCESS = 'Centros médicos CCMS: OI. Consulta',
  CHECKUP_ACCESS = 'Chequeo médico CCMS: OI. Acceso',
  APPOINTMENT_ACCESS = 'Cita médica CCMS: OI. Acceso',
}
